module.exports = __webpack_public_path__ + "img/locked-new-bg.b00ce499.svg";